import hljs from 'highlight.js'

const allowedHtmlTags = ['b', 'sub', 'sup', 'u', 'br']

const monthsString = [
  'Ian',
  'Feb',
  'Mar',
  'Apr',
  'Mai',
  'Iun',
  'Iul',
  'Aug',
  'Sep',
  'Oct',
  'Noi',
  'Dec',
]

const daysOfWeek = [
  'Duminică',
  'Luni',
  'Marți',
  'Miercuri',
  'Joi',
  'Vineri',
  'Sâmbătă',
]

export const maxCharachterWidth = 13.8

export const renderHtml = text => {
  let formattedText = ''
  if (text) {
    formattedText = text.replaceAll('\n', '<br>')
    // text = text.replaceAll('&', '&amp;') // breaking matrices, comment for now
    formattedText = text.replaceAll('<', '&lt;')
    formattedText = text.replaceAll('>', '&gt;')
    formattedText = text.replaceAll('"', '&quot;')
    formattedText = text.replaceAll("'", '&apos;')

    for (const htmlTag of allowedHtmlTags) {
      formattedText = text.replaceAll(`&lt;${htmlTag}&gt;`, `<${htmlTag}>`)
      formattedText = text.replaceAll(`&lt;/${htmlTag}&gt;`, `</${htmlTag}>`)
    }
  }
  return formattedText
}

export const getChoicesClass = (windowSize, maxChoiceLength) => {
  const numberOfChoices =
    (windowSize - 20) / (maxCharachterWidth * (maxChoiceLength + 3))

  if (numberOfChoices !== Infinity) {
    if (numberOfChoices >= 6) {
      return 'grid-cols-6'
    }
    if (numberOfChoices >= 3) {
      return 'grid-cols-3'
    }
    if (numberOfChoices >= 2) {
      return 'grid-cols-2'
    }
  }
  return 'grid-cols-1'
}

export const getCurrentDimension = () => {
  return {
    width: window.innerWidth,
    height: window.innerHeight,
  }
}

export const getMaxLength = contentArray => {
  let max = 0

  contentArray?.forEach(content => {
    let text = content
    let breakLineIndex = text?.indexOf('\n')
    while (text?.length > 0 && breakLineIndex !== -1) {
      const line = text.substring(0, breakLineIndex)
      if (line?.length > max) {
        max = line?.length
      }

      text = text?.substring(breakLineIndex + 1, text?.length)
      breakLineIndex = text?.indexOf('\n')
    }
    if (text?.length > max) {
      max = text?.length
    }
  })

  return max
}

export const getMaxChoiceLength = grila => {
  const variante = Array.from(
    grila?.filter(function (item) {
      return typeof item?.type === 'string' && item?.type?.includes('choice-')
    }) ?? [],
  )

  const contentVariante = []
  variante?.forEach(varianta => {
    contentVariante.push(varianta.content)
  })

  return getMaxLength(contentVariante)
}

export const getDateString = date => {
  return `${date.getDate() >= 10 ? date.getDate() : `0${date.getDate()}`}.${
    date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : `0${date.getMonth() + 1}`
  }.${date.getFullYear()}`
}

export const getHourString = date => {
  return `${date.getHours()}:${
    date.getMinutes() >= 10 ? date.getMinutes() : `0${date.getMinutes()}`
  }`
}

export const getDowString = date => {
  return daysOfWeek[date.getDay()]
}

export const getFullDateHourString = date => {
  return `${getDateString(date)} ${getHourString(date)}`
}

export const prefixString20 = value => {
  if (value > 20) {
    return `${value} de`
  } else {
    return `${value}`
  }
}

export const getSmartDateComments = date => {
  const currentDate = new Date()

  const dateDifferenceInHours = Math.floor(
    (currentDate.getTime() - date.getTime()) / (3600 * 1000),
  )
  const dateDifferenceInMinutes = Math.floor(
    (currentDate.getTime() - date.getTime()) / (60 * 1000),
  )

  if (dateDifferenceInHours < 24) {
    if (dateDifferenceInHours === 0) {
      if (dateDifferenceInMinutes === 0) {
        return 'în urmă cu câteva secunde'
      }
      return `în urmă cu ${prefixString20(dateDifferenceInMinutes)} minute`
    }
    return `în urmă cu ${prefixString20(dateDifferenceInHours)} ore`
  }

  return `${monthsString[date.getMonth()]} ${date.getDate()}`
}

export const getLast7DaysInterval = () => {
  const currentDate = new Date()
  currentDate.setHours(0, 0, 0, 0)

  const startDate = new Date(currentDate)
  startDate.setDate(currentDate.getDate() - 6)

  const endDate = new Date()
  endDate.setHours(23, 59, 59, 999)

  return {
    start: startDate,
    end: endDate,
  }
}

export const getLast7DaysOfWeek = () => {
  const interval = getLast7DaysInterval()
  const startDate = interval.start

  const daysArray = []

  for (let i = 0; i < 7; i++) {
    const dayIndex = startDate.getDay()
    daysArray.push(daysOfWeek[dayIndex])
    startDate.setDate(startDate.getDate() + 1)
  }

  return daysArray
}

export const getLastFullYearBoundsFromCurrentDate = () => {
  const today = new Date()
  const currentYear = today.getFullYear()

  const startOfYear = new Date(
    currentYear - 1,
    today.getMonth(),
    today.getDate(),
    0,
    0,
    0,
    0,
  )

  const endOfYear = new Date(
    currentYear,
    today.getMonth(),
    today.getDate(),
    23,
    59,
    59,
    999,
  )

  return {
    start: startOfYear,
    end: endOfYear,
  }
}

export const titleCase = str => {
  return str.replace(
    /\w\S*/g,
    text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase(),
  )
}

export const monthNames = [
  'ianuarie',
  'februarie',
  'martie',
  'aprilie',
  'mai',
  'iunie',
  'iulie',
  'august',
  'septembrie',
  'octombrie',
  'noiembrie',
  'decembrie',
]

export const getLast12Months = () => {
  const currentDate = new Date()
  const currentMonth = currentDate.getMonth()
  const currentYear = currentDate.getFullYear()

  let smallestYear = currentYear
  let largestYear = currentYear

  const monthsArray = []
  for (let i = 11; i >= 0; i--) {
    const previousMonthIndex = (currentMonth - i + 12) % 12
    let previousMonthYear = currentYear
    if (previousMonthIndex > currentMonth) {
      previousMonthYear--
    }
    if (previousMonthYear < smallestYear) {
      smallestYear = previousMonthYear
    }
    if (previousMonthYear > largestYear) {
      largestYear = previousMonthYear
    }
    monthsArray.push(
      `${titleCase(monthNames[previousMonthIndex])} ${previousMonthYear}`,
    )
  }

  return { monthsArray, smallestYear, largestYear }
}

export const circularRightShift = (array, number) => {
  let N = number
  const length = array.length
  N = N % length
  const shifted = array.splice(length - N, N)
  return shifted.concat(array)
}

export const getCorrectSolvedGrids = gridsArray => {
  return gridsArray?.filter(grid => {
    if (
      grid?.choice === grid?.answer ||
      grid?.choice === grid?.correct_answer
    ) {
      return grid
    }
  })
}

export const handleGetGridDifficulty = difficulty => {
  if (difficulty >= 0 && difficulty < 0.29) {
    return <span className="text-error">Grea</span>
  } else if (difficulty >= 0.29 && difficulty < 0.87) {
    return <span className="text-partially-correct">Medie</span>
  } else {
    return <span className="text-correct">Usoară</span>
  }
}
export const formatTime = seconds => {
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = seconds % 60

  let timeString = ''

  if (hours > 0) {
    timeString += `${String(hours).padStart(2, '0')}:`
  }

  timeString += `${String(minutes).padStart(2, '0')}:`
  timeString += String(secs).padStart(2, '0')

  return timeString
}

export const getHighlighedCode = code => {
  if (!code) return
  return hljs?.highlight(code, { language: 'cpp' }).value
}

export const generatePassword = () => {
  const chars =
    'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+'
  let password = ''
  for (let i = 0; i < 12; i++) {
    password += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  return password
}

export const getDifficultySpans = difficulty => {
  if (difficulty >= 0 && difficulty < 0.29) {
    return <span className="text-error">Grea</span>
  } else if (difficulty >= 0.29 && difficulty < 0.87) {
    return <span className="text-partially-correct">Medie</span>
  } else {
    return <span className="text-correct">Usoară</span>
  }
}

export const handleConvertTagsId = (tagIds, allTags) => {
  const tagNames = []
  for (let index = 0; index < tagIds.length; index++) {
    const tag = allTags?.find(tag => tag.id === tagIds[index])
    if (tag) {
      tagNames.push(tag.name)
    }
  }
  return tagNames
}

export const filterGridsByDifficulty = (defaultGrids, difficultyFilters) => {
  if (defaultGrids === undefined || difficultyFilters === undefined) {
    return defaultGrids
  }

  const checkedLength = difficultyFilters.filter(
    difficulty => difficulty?.checked,
  ).length

  if (checkedLength === 1) {
    const checkedDifficulty = difficultyFilters?.filter(
      difficulty => difficulty?.checked,
    )
    const minValue = checkedDifficulty[0]?.minValue
    const maxValue = checkedDifficulty[0]?.maxValue
    return defaultGrids?.filter(grid => {
      const difficulty = grid?.difficulty
      if (difficulty >= minValue && difficulty <= maxValue) {
        return grid
      }
    })
  } else if (checkedLength === 2) {
    const checkedDifficulty = difficultyFilters.filter(
      difficulty => difficulty.checked,
    )
    const minValue1 = checkedDifficulty[0]?.minValue
    const maxValue1 = checkedDifficulty[0]?.maxValue
    const minValue2 = checkedDifficulty[1]?.minValue
    const maxValue2 = checkedDifficulty[1]?.maxValue
    return defaultGrids?.filter(grid => {
      const difficulty = grid?.difficulty
      if (
        (difficulty >= minValue1 && difficulty <= maxValue1) ||
        (difficulty >= minValue2 && difficulty <= maxValue2)
      ) {
        return grid
      }
    })
  } else if (checkedLength === 3) {
    return defaultGrids
  }

  return defaultGrids
}

export const handleVerifyTagsInFilter = (grid, tags) => {
  for (let index = 0; index < grid.tags.length; index++) {
    if (tags.includes(grid.tags[index])) {
      return true
    }
  }
  return false
}

export const orderAnswerOptionsDescending = answerText => {
  let newAnswer = answerText?.[0]

  for (let index = 1; index < answerText.length; index++) {
    let index2 = 0
    while (
      index2 < newAnswer.length &&
      parseInt(answerText[index]) < parseInt(newAnswer[index2])
    ) {
      index2++
    }
    if (index2 < newAnswer.length) {
      newAnswer =
        newAnswer.substr(0, index2) +
        answerText[index] +
        newAnswer.substr(index2)
    } else {
      newAnswer += answerText[index]
    }
  }

  return parseInt(newAnswer)
}

export const handleGetDate = timestamp => {
  const date = new Date(timestamp * 1000)
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()

  return `${day}/${month}/${year}`
}

export const handleFilterByGrilaType = (grids, grileTypes) => {
  if (grids === undefined || grileTypes === undefined) {
    return grids
  }
  if (grileTypes[0].checked === true && grileTypes[1].checked === true) {
    return grids
  } else if (
    grileTypes[0].checked === true &&
    grileTypes[1].checked === false
  ) {
    return grids.filter(grid => grid.multiple_choice === false)
  } else if (
    grileTypes[0].checked === false &&
    grileTypes[1].checked === true
  ) {
    return grids.filter(grid => grid.multiple_choice === true)
  }

  return grids
}
export const getIsPartiallyCorrect = (answer, userChoice) => {
  if (answer === undefined || userChoice === undefined) {
    return false
  }

  const answerString = String(answer)
  const userChoiceString = String(userChoice)

  for (let index = 0; index < userChoiceString.length; index++) {
    if (answerString.indexOf(userChoiceString[index]) !== -1) {
      return true
    }
  }

  return false
}

export const isAnswerCorrect = (userAnswer, answer) => {
  try {
    return (
      userAnswer.toString().split('').sort().join('') ===
      answer.toString().split('').sort().join('')
    )
  } catch (error) {
    return false
  }
}

const addPagesUrl = (text, books, book) => {
  if (!text || (!book && !books)) {
    return text
  }

  let new_text = text

  if (text.includes('<page')) {
    // <page#page_nr#book_id#text_to_display>
    const fileMatches = text.matchAll(/<page#\d+#\d+#.*?>/g)

    for (const match of fileMatches) {
      const startIndex = match.index + 1
      const distance = text.indexOf('>', startIndex) - startIndex
      const fileDetails = text
        .substring(startIndex, startIndex + distance)
        .split('#')

      const pageNr = fileDetails[1]
      const bookId = fileDetails[2]
      const label = fileDetails[3] || '(vezi aici pagina)'

      const currentBook = books?.find(book => book.id === parseInt(bookId))

      if (!currentBook) {
        console.error(`Book with ID ${bookId} not found`)
        continue
      }

      const pages_new_str = `<a href='https://storage.grile.info/${
        process.env.REACT_APP_TYPE
      }/books/${currentBook.name}#page=${
        parseInt(pageNr) + parseInt(currentBook.page_offset)
      }' target='_blank' rel="noreferrer" style='background-color:rgba(var(--primary))'>${label}</a>`

      new_text = new_text.replace(match[0], pages_new_str)
    }
  } else if (book) {
    // pagina <page_nr>

    const page_strings = [
      ...text.matchAll(/(paginile|pagina)[ ]*[0-9]*(,[ ]*[0-9]*)*/g),
    ]

    for (const page_string of page_strings) {
      const pages_new_str = page_string[0].replace(/(\d+)/g, (match, page) => {
        return `<a href='https://storage.grile.info/${
          process.env.REACT_APP_TYPE
        }/books/${book.book_name}#page=${
          parseInt(page) + book.book_page_offset
        }' target='_blank' rel="noreferrer" style='background-color:rgba(var(--primary))'>${page}</a>`
      })
      new_text = new_text.replace(page_string[0], pages_new_str)
    }
  }

  return new_text
}

const expandFiles = text => {
  let expandedText = text

  try {
    const fileMatches = text.matchAll(/<file/g)
    for (const match of fileMatches) {
      const startIndex = match.index + 1
      const stopIndex = text.indexOf('>', startIndex) - startIndex
      const fileDetails = text.substr(startIndex, stopIndex).split('#')
      const fileName = fileDetails[1]
      const label = fileDetails[2] || '(vezi aici)'

      expandedText = expandedText.replace(
        text.substr(startIndex - 1, stopIndex + 2),
        `<a href='https://storage.grile.info/${process.env.REACT_APP_TYPE}/explain/${fileName}' class='bg-purple-500/50' target='_blank'>${label}</a>`,
      )
    }
  } catch (err) {
    console.error(err)
  }
  return expandedText
}

const replaceNewLines = text => {
  if (text.includes('<br>') || text.includes('$') || text.includes('\[')) {
    return text
  }
  let new_text = text.replaceAll('\n', '<br>')

  return new_text
}

export const formatExplanation = (explanation, books, book) => {
  return replaceNewLines(addPagesUrl(expandFiles(explanation), books, book))

  // let add = ''

  // if (pages) {
  //   add =
  //     'Găsești mai multe informații în carte, la ' +
  //     (pages.length === 1 ? 'pagina ' : 'paginile ') +
  //     pages.join(', ') +
  //     '.'
  // }

  // if (explanation) {
  //   return explanation + '<br><br>' + add
  // }

  // if (pages) {
  //   return add
  // }

  // return undefined
}

export const toBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = reject
  })

export const removeTutorialOverlay = () => {
  const tutorialOverlay = document.getElementById('tutorial-overlay')
  if (tutorialOverlay) {
    tutorialOverlay.remove()
  }
}
